/*
 * @Author: your name
 * @Date: 2020-10-10 16:34:38
 * @LastEditTime: 2020-10-27 10:24:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\static\js\filter.js
 */

const spliceText=function  (value,num) {
    if (!value) return ''  
    var length=num||40
    value = value.slice(0,length)+'...' 
    return value
  }

const setTime=function(value,type){
  // console.log(value)
}
const num=function (value,type) { 
  var len=type||100
  var val =  Math.round(value*len)
  return val/len 
}

  export {spliceText,setTime,num}

  


 


// WEBPACK FOOTER //
// ./static/js/filter.js